// extracted by mini-css-extract-plugin
export default {"melodyVideo":"pJ-z","isFullWidth":"qJ-z","landingPageVideo":"rJ-z","play":"sJ-z","iframeVideo":"tJ-z","playHidden":"uJ-z","fullwidth":"vJ-z"};